@if (tray) {
    <div class="tray-title" (click)="closeTray.emit($event)">
        <div
            class="accessibility-tray-title"
            cdkFocusInitial
            tabindex="0"
            (keydown.enter)="closeTray.emit($event)"
            (keydown.space)="closeTray.emit($event)">
            <div class="tray-title-i18n">
                @if (tray.titleKey) {
                    <span
                        role="heading"
                        aria-level="2"
                        [id]="'tray-title-' + tray.uuid"
                        [class]="tray.titleKey === 'hermes-categories-tree.shop' ? 'heading-2' : 'heading-3'">
                        @switch (tray.titleKey) {
                            <!-- Add your tray title here -->

                            <!-- Product Locator tray title -->
                            @case ("hermes-global-translations.filter-by") {
                                <ng-container i18n="@@hermes-global-translations.filter-by"> Filter by </ng-container>
                            }
                            <!-- Size guide tray title -->
                            @case ("hermes_commerce.size-guide") {
                                <ng-container i18n="@@hermes_commerce.size-guide"> Size Guide </ng-container>
                            }
                            <!-- Menu tray title -->
                            @case ("hermes-categories-tree.shop") {
                                <ng-container i18n="@@hermes-categories-tree.shop"> Menu </ng-container>
                            }
                            <!-- Shop locations countries (or cities) tray title -->
                            @case ("hermes-country-selector-tray.country") {
                                <ng-container i18n="@@hermes-country-selector-tray.country"> Location </ng-container>
                            }
                            <!-- Product Locator tray title -->
                            @case ("hermes.commerce.product_locator.title") {
                                <ng-container i18n="@@hermes.commerce.product_locator.title">
                                    Find in store
                                </ng-container>
                            }
                            <!-- E-Reservation tray title -->
                            @case ("hermes.e-reservation.tray-title") {
                                <ng-container i18n="@@hermes.e-reservation.tray-title"> E-reservation </ng-container>
                            }
                            <!-- Back in stock tray title -->
                            @case ("hermes.back-in-stock.tray.subscription.title") {
                                <ng-container i18n="@@hermes.back-in-stock.tray.subscription.title">
                                    Notify me
                                </ng-container>
                            }
                            <!-- Identification tray title -->
                            @case ("hermes.identification.tray-title") {
                                <ng-container i18n="@@hermes.identification.tray-title">Identification </ng-container>
                            }
                            <!-- Register your interest tray title -->
                            @case ("hermes.back-in-stock_exceptional-pieces.tray.subscription.title") {
                                <ng-container i18n="@@hermes.back-in-stock_exceptional-pieces.tray.subscription.title">
                                    Register
                                </ng-container>
                            }
                            <!--Newsletter tray title -->
                            @case ("hermes.accessibility.forms.checkout.newsletter.title") {
                                <ng-container lang="en" i18n="@@hermes.common.newsletter"> Newsletter </ng-container>
                                <span class="sr-only" i18n="@@hermes.accessibility.forms.checkout.newsletter.title">
                                    Subscribe to the newsletter
                                </span>
                            }
                            <!-- Geofiltering tray title -->
                            @case ("hermes.header_notification.geo_filtering_banner.title") {
                                <ng-container i18n="@@hermes.header_notification.geo_filtering_banner.title">
                                    Welcome on Hermes.com
                                </ng-container>
                            }
                            @case ("hermes-global-translations.filter") {
                                <ng-container i18n="@@hermes-global-translations.filter"> Filter </ng-container>
                            }
                            <!-- Default case that should not happen -->
                            @default {
                                <ng-container i18n="@@hermes-global.translations.translation-key-not-found">
                                    Translation key not found : {{ tray.titleKey }}
                                </ng-container>
                            }
                        }
                    </span>
                } @else {
                    {{ tray.translatedTitle }}
                }
                @if (tray.titleKey === "hermes-global-translations.filter") {
                    <span class="sr-only" i18n="@@hermes.accessibility.information_apply_filter">
                        Selecting a filter will apply the update to the products displayed on the page
                    </span>
                }
            </div>
            <h-close-button tabindex="-1" [iconSize]="'12px'" class="tray-close-button"> </h-close-button>
        </div>
    </div>
}
